import React, {useState, useEffect} from "react";
import "./TextLong.css";

export default function TextLong(props) {

  const textLong=props.textLong;

  const width= window.innerWidth;

  useEffect(() => {
    const width= window.innerWidth;
  }, []);

  const paragraphs = textLong.split("\r\n\r\n");
  // console.log(paragraphs);

  const processParagraph = (paragraph) => {
    const splitForOpeningTag = paragraph.split("<");
    const processNoTag = (seg) => {
      const splitForClosingTag = seg.split(">");
      return splitForClosingTag.length > 1
        ? splitForClosingTag[1]
        : splitForClosingTag[0];
    };

    const processTag = (seg) => {
      // console.log(seg, text);
      const splitForClosingTag = seg.split(">");
      const tag = splitForClosingTag[0];
      const content = splitForClosingTag[1];

      if (tag === "h") {
        return <span className="text-long-highlight">{content}</span>;
      }
      if (tag === "b") {
        return <span className="text-long-bold">{content}</span>;
      }
      if (tag === "i") {
        return <span className="text-long-italic">{content}</span>;
      }
      if (tag === "l") {
        return (
          <a
            className="text-long-link"
            rel="noreferrer"
            href={content.split("(")[1].split(")")[0]}
            target="_blank"
          >
            {content.split("(")[0]}
          </a>
        );
      }
      return content;
    };

  return (
    props.isMobile ? 
      <p className="text-long-mobile">
          {splitForOpeningTag.map((s, i) =>
            i % 2 === 0
              ? processNoTag(splitForOpeningTag[i])
              : processTag(splitForOpeningTag[i])
          )}
     </p>
     :
     <p className="text-long">
     {splitForOpeningTag.map((s, i) =>
       i % 2 === 0
         ? processNoTag(splitForOpeningTag[i])
         : processTag(splitForOpeningTag[i])
     )}
  </p>
  );
}
  return (
  <div>
  <div 
  style={{
    color: "#F8F8FF",
    backgroundColor: "black",
    padding: width>=900 ? "5px 25vw 10px 25vw": "5px 10vw 10px 10vw",
    textAlign: "left",
    overflow: "hidden",
  }}>
    {paragraphs.map((p) => processParagraph(p))}
  </div>
  </div>
  )
}
